var map = {
	"./Alfin-Banco.svg": "f172",
	"./BBVA.svg": "1e43",
	"./Banco-Falabella.svg": "0eac",
	"./Banco-GNB.svg": "4f30",
	"./Banco-Ripley.svg": "384c",
	"./Banco-Santander-Peru.svg": "2bc7",
	"./Bank-of-China.svg": "74e7",
	"./Bci-Peru.svg": "99c6",
	"./Compartamos.svg": "3d71",
	"./Confianza.svg": "ea5f",
	"./Credinka.svg": "55ee",
	"./Crediscotia.svg": "b16d",
	"./Efectiva.svg": "cc0b",
	"./ICBC-PERU-BANK.svg": "4e83",
	"./MiBanco.svg": "704a",
	"./Mitsui-Auto-Finance.svg": "07a8",
	"./Oh.svg": "4d89",
	"./Proempresa.svg": "c001",
	"./Qapaq.svg": "71e0",
	"./agrobanco.svg": "9da3",
	"./banbif.svg": "b5c5",
	"./banco-pichincha.svg": "9990",
	"./bancom.svg": "a244",
	"./bcp.svg": "54fe",
	"./bdelanacion.svg": "b08d",
	"./caja-arequipa.svg": "e862",
	"./caja-cuzco.svg": "efaa",
	"./caja-del-santa.svg": "320e",
	"./caja-huancayo.svg": "35d2",
	"./caja-ica.svg": "0c42",
	"./caja-maynas.svg": "c1f2",
	"./caja-municipal.svg": "2ead",
	"./caja-paita.svg": "8c6e",
	"./caja-piura.svg": "fffd",
	"./caja-sullana.svg": "2437",
	"./caja-tacna.svg": "6916",
	"./caja-trujillo.svg": "3c84",
	"./citibank.svg": "0dfa",
	"./cofide.svg": "a93f",
	"./interbank.svg": "c362",
	"./mivivienda.svg": "0ab0",
	"./scotiabank.svg": "e6f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f3d";